(() => {
  const mobile = window.matchMedia('(max-width: 989px)');

  function bind(header) {
    if (header.classList.contains('tj-mobile-search-ready')) return;
    const search = header.querySelector('.header__search');
    const form = search?.querySelector('form');
    const input = form?.querySelector('input[type="search"]');
    const submit = form?.querySelector('.search__button');
    const field = form?.querySelector('.field');
    if (!input || !submit || !field) return;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'tj-mobile-search-toggle';
    toggle.setAttribute('aria-label', submit.getAttribute('aria-label') || 'Search');
    toggle.setAttribute('aria-expanded', 'false');
    if (!form.id) form.id = `tj-mobile-search-${header.closest('.shopify-section')?.id || 'header'}`;
    toggle.setAttribute('aria-controls', form.id);
    const icon = submit.querySelector('svg');
    if (icon) toggle.appendChild(icon.cloneNode(true));
    else toggle.textContent = 'Search';
    search.appendChild(toggle);

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'tj-mobile-search-close';
    close.setAttribute('aria-label', 'Close search');
    close.textContent = '×';
    field.appendChild(close);
    const predictive = search.querySelector('predictive-search');
    const drawer = header.querySelector('header-drawer');
    const menu = drawer?.querySelector('details');

    function hide(restoreFocus = false) {
      if (!header.classList.contains('tj-mobile-search-open')) return;
      header.classList.remove('tj-mobile-search-open');
      form.classList.remove('active');
      field.classList.remove('shown');
      toggle.setAttribute('aria-expanded', 'false');
      predictive?.close?.();
      if (restoreFocus) toggle.focus();
      else if (form.contains(document.activeElement)) document.activeElement.blur();
    }

    function show(event) {
      if (menu?.open) {
        if (typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event);
        else {
          menu.open = false;
          menu.classList.remove('menu-opening');
          menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          window.removeTrapFocus?.();
          document.body.classList.remove('overflow-hidden-mobile');
          document.querySelector('.header-menu__overlay-element')?.classList.remove('shown');
        }
      }
      header.classList.add('tj-mobile-search-open');
      form.classList.add('active');
      field.classList.add('shown');
      toggle.setAttribute('aria-expanded', 'true');
      // Keep focus in the original tap gesture so iOS can open the keyboard.
      input.focus({ preventScroll: true });
    }

    toggle.addEventListener('click', (event) => {
      if (!mobile.matches) return;
      event.preventDefault();
      event.stopPropagation();
      if (header.classList.contains('tj-mobile-search-open')) hide(true);
      else show(event);
    });

    // The existing predictive-search icon handler toggles instead of submitting.
    // On mobile the dedicated toggle opens the panel; this icon submits it.
    header.addEventListener('click', (event) => {
      if (!mobile.matches || !event.target.closest('.header__search .search__button')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (input.value.trim()) form.requestSubmit();
      else input.focus({ preventScroll: true });
    }, true);
    close.addEventListener('click', () => hide(true));
    search.addEventListener('keydown', (event) => {
      if (!mobile.matches || event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      hide(true);
    });
    document.addEventListener('click', (event) => {
      if (mobile.matches && !search.contains(event.target)) hide();
    });
    menu?.addEventListener('toggle', () => { if (menu.open) hide(); });
    mobile.addEventListener('change', () => { if (!mobile.matches) hide(); });
    header.classList.add('tj-mobile-search-ready');
  }

  function init(root = document) {
    root.querySelectorAll('[data-theme-preset="garage"] .header-wrapper .header').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();
